import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { DynamicFieldModel } from '@share';
import { HttpParams } from '@angular/common/http';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { LoadingService } from 'src/app/share/services/loading.service';
import { PriceChangeDateService } from './price-change-date.service';

@Component({
  selector: 'app-price-change-date',
  imports: [DynamicTableComponent, CommonModule],
  providers: [NzModalService],
  templateUrl: './price-change-date.component.html',
  styleUrl: './price-change-date.component.scss'
})
export class PriceChangeDateComponent implements OnInit {
  total = 0;
  list: any[] = [];
  width: string;

  schema = {
    name: "Price Change Date List",
    permissionKey: "pricechangedate",
    enableDelete: true,
    enableEdit: false,
    enableAdd: true,
    size: "small",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px",
        isStickyRight: false,
        isStickyLeft: true,
      },
      {
        key: "date",
        title: "Date",
        type: "dateOnly",
        searchType: "date",
        enableSearch: true,
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "action",
        title: "Actions",
        type: "button",
        width: "150px",
        isStickyRight: true,
        isStickyLeft: false,
        label: [
          // { name: "edit", type: "edit", isDanger: false, isEnable: true }, 
          { name: "delete", type: "danger", isEnable: true }]
      }
    ]
  };

  fieldConfig: Array<DynamicFieldModel> = [
    {
      label: 'Date',
      name: 'date',
      type: 'date',
      placeholder: '',
      required: true,
      autofocus: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Date required',
        },
      ],
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    },
  ];

  constructor(private readonly modalService: NzModalService, private readonly loadingService: LoadingService, private readonly service: PriceChangeDateService, private readonly cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.calculateWidth();
    let params = new HttpParams()
      .set('page', this.schema.pageIndex.toString())
      .set('pageSize', this.schema.pageSize.toString());
    this.loadData(params);
  }

  @HostListener('window:resize')
  calculateWidth() {
    const offsetWidth = 300;
    this.width = `${window.innerWidth - offsetWidth}px`;
  }

  change(data: { [key: string]: any }) {
    let params = new HttpParams()
      .set('page', data['pageIndex'].toString())
      .set('pageSize', data['pageSize'].toString())
      .set('filterValue', JSON.stringify(data['filters']))
      .set('sort', JSON.stringify(data['sorts']));
    this.loadData(params);
  }

  loadData(param: HttpParams = null) {
    this.loadingService.toggleTableLoading();
    this.cdr.detectChanges();
    this.service.getItems(param).subscribe({
      next: x => {
        this.list = x.data;
        this.total = x.totalCount;
      },
      error: err => { this.loadingService.toggleTableLoading(); this.cdr.detectChanges(); },
      complete: () => { this.loadingService.toggleTableLoading(); this.cdr.detectChanges(); }
    });
  }

  formEvent(data: any) {
    if (data.id) {
      this.service.updateItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
    else if (data.deleted_id) {
      this.modalService.confirm({
        nzTitle: 'Are you sure want to delete?',
        nzContent: 'This action cannot be undone.',
        nzOkText: 'Yes',
        nzCancelText: 'No',
        nzOnOk: () => {
          this.service.deleteItem(data).subscribe(x => {
            let params = new HttpParams()
              .set('page', this.schema.pageIndex.toString())
              .set('pageSize', this.schema.pageSize.toString());
            this.loadData(params);
          });
        },
        nzOnCancel: () => {
        }
      });
    }
    else {
      this.service.createItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
  }
}
